import React from "react";
import PropTypes from "prop-types";

const Box = ({ className, count, getActiveLink, title }) => {
  return (
    <div className={`block-container ${className}`}>
      <div className="inner">
        <h1>{count}</h1>
        <div>
          <p style={{ textDecoration: getActiveLink ? "underline" : "none" }}>
            {title}
          </p>
          {getActiveLink && <i className="fas fa-external-link-alt"></i>}
        </div>
      </div>
    </div>
  );
};

Box.propTypes = {
  className: PropTypes.string,
  count: PropTypes.number.isRequired,
  getActiveLink: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

Box.defaultProps = {
  className: "",
  getActiveLink: false,
};

export default Box;
